/**
 * 웹/PWA "이 기기에서 알림 받기" 플래그 (기기별 설정 — localStorage).
 *
 * Tauri의 tauriNotifyEnabled(deviceService)와 대칭이다. services가 아니라 utils에 두는 이유:
 * utils/webNotification.ts(페이지 알림 단일 경로)도 이 값을 읽어야 하는데 utils → services
 * 역참조를 만들 수 없다.
 *
 * ⚠ 키 부재 = 켜짐. 반대로 하면 배포 순간 전 기기의 알림이 꺼진다.
 * ⚠ 이 키는 세션 데이터가 아니라 기기 설정이다 — App.tsx handleLogout의 localStorage 정리에서
 *   지우면 안 된다 (disclaimer:{userId}를 남기는 것과 같은 논리).
 *
 * 소비처:
 * - webPushService.subscribeToPush() 첫 줄 가드 — 자동 재구독 경로 전부를 한 지점에서 막는다
 * - webNotification.showWebNotification() 첫 줄 가드 — 화면을 보는 중의 시스템 알림도 끈다
 * - pushSupport.describePushStatus / pickNotificationBanner — 상태 문구·권한 배너 억제
 */

const KEY = 'webNotifyEnabled';

export const isWebNotifyEnabled = (): boolean => {
  try {
    return localStorage.getItem(KEY) !== 'false';
  } catch {
    // 접근 불가 환경(프라이빗 모드 등)에서는 기본값(켜짐)으로 동작한다
    return true;
  }
};

export const setWebNotifyEnabled = (enabled: boolean): void => {
  try {
    if (enabled) {
      localStorage.removeItem(KEY); // 기본값과 같으면 키를 남기지 않는다
    } else {
      localStorage.setItem(KEY, 'false');
    }
  } catch {
    // 저장 실패는 조용히 — 다음 부팅에 기본값으로 돌아갈 뿐이다
  }
};
